import React, { Component }          from 'react';
import Select                        from 'react-select'
import { ROLES }                     from '../../common/Common';

import { TIMEZONES }                 from '../../common/Timezones';
import icClose                       from '../../../img/ic_close.svg';
import * as EmailValidator           from 'email-validator';
import "./Dialog.scss";
import axios from 'axios';

const DEFAULT_TIMEZONE = 'Eastern Standard Time';

class LocationsDialog extends Component {

  constructor(props) {
    super(props);

    this.state            = {
      name: '',
      city: '',
      state: '',
      country: '',
      timezone: DEFAULT_TIMEZONE,
      accessKey: '',
      urlKey: '',
      contactEmail: '',
      infoLink: '',
      infoLinkText: '',
      sponsoredIcon: null,
      mainIcon: null,
      translationFile: null,
      iconKey: '',
      mainIconKey: '',
      currentErrorMessages: []
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      if (this.props.editingLocation) {
        console.log(this.props.editingLocation)
        this.setState({
          name: this.props.editingLocation.name,
          city: this.props.editingLocation.city,
          state: this.props.editingLocation.state,
          country: this.props.editingLocation.country,
          timezone: this.props.editingLocation.timezone,
          iconKey: this.props.editingLocation.iconKey,
          mainIconKey: this.props.editingLocation.mainIconKey,
          urlKey: this.props.editingLocation.urlKey,
          contactEmail: this.props.editingLocation.contactEmail,
          infoLink: this.props.editingLocation.infoLink,
          infoLinkText: this.props.editingLocation.infoLinkText,
          translationData: this.props.editingLocation.translationData,
          mainIcon: null,
          sponsoredIcon: null,
        })
      } else if (!this.props.editingLocation) {
        console.log('SET EDITING ADMIN')
        this.setState({
          name: '',
          city: '',
          state: '',
          country: '',
          timezone: DEFAULT_TIMEZONE,
          iconKey: '',
          urlKey: '',
          contactEmail: '',
          infoLink: '',
          infoLinkText: '',
          mainIconKey: '',
          translationData: null,
          mainIcon: null,
          sponsoredIcon: null,
        })
      }
    }
  }

  onFieldChange(name, event) {
    if (name === "sponsoredIcon") {
      const file = event.target.files[0];
      this.setState({sponsoredIcon: file});
    } else if (name === "mainIcon") {
      const file = event.target.files[0];
      this.setState({mainIcon: file});
    } else if (name === "translationFile") {
      const file = event.target.files[0];
      this.setState({translationFile: file});
    } else if (name === "urlKey") {
      const key = event.target.value;
      if (key) {
        this.setState({urlKey: key.replace(/\s/g, '')})
      }
    } else {
      this.setState({[name]: event.target.value});
    }
  }

  onMultiSelectChange(name, data) {
    this.setState({[name]: data});
  }

  getTitleText() {
    return this.props.editingLocation ? 'Edit Location' : 'Create Location';
  }

  getSubmitText() {
    return this.props.editingLocation ? 'SAVE' : 'ADD';
  }

  renderTimeZones() {
    return TIMEZONES.map((timezone, i) => {
      return <option key={i} value={timezone.value}>{timezone.text}</option>
    })
  }

  isValidUrl(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }

  errorsToShow() {
    const errors = [];
    if (this.state.email && !EmailValidator.validate(this.state.email)) {
      errors.push("Please enter a valid email address.")
    }

    if (this.state.infoLink && !this.isValidUrl(this.state.infoLink)) {
      errors.push("Please enter a valid http link in the Info Link field")
    }
    return errors;
  }

  isReadyToSubmit() {
    if (this.props.editingLocation) {
      return this.state.name !== this.props.editingLocation.name ||
             this.state.city !== this.props.editingLocation.city ||
             this.state.state !== this.props.editingLocation.state ||
             this.state.country !== this.props.editingLocation.country ||
             this.state.timezone !== this.props.editingLocation.timezone ||
             this.state.urlKey !== this.props.editingLocation.urlKey ||
             this.state.contactEmail !== this.props.editingLocation.contactEmail ||
             this.state.infoLink !== this.props.editingLocation.infoLink ||
             this.state.infoLinkText !== this.props.editingLocation.infoLinkText ||
             this.state.iconKey !== this.props.editingLocation.iconKey ||
             this.state.mainIconKey !== this.props.editingLocation.mainIconKey ||
             this.state.translationData !== this.props.editingLocation.translationData ||
             this.state.translationFile ||
             this.state.mainIcon ||
             this.state.sponsoredIcon;
    } else {
      return this.state.name.length > 0 && this.state.city.length > 0 && this.state.country.length > 0 && this.state.country.length > 0;
    }
  }

  save() {
    if (this.isReadyToSubmit()) {
      const currentErrorMessages = this.errorsToShow();
      if (currentErrorMessages.length === 0) {
        this.setState({currentErrorMessages: []})
        if (this.props.editingLocation) {
          this.props.saveLocation({
            id: this.props.editingLocation.id,
            name: this.state.name,
            city: this.state.city,
            state: this.state.state,
            country: this.state.country,
            timezone: this.state.timezone,
            urlKey: this.state.urlKey,
            contactEmail: this.state.contactEmail,
            infoLink: this.state.infoLink,
            infoLinkText: this.state.infoLinkText,
            iconKey: this.state.iconKey,
            mainIconKey: this.state.mainIconKey,
            sponsoredIcon: this.state.sponsoredIcon,
            translationFile: this.state.translationFile,
            translationData: this.state.translationData,
            mainIcon: this.state.mainIcon
          })
        } else {
          this.props.saveLocation({
            name: this.state.name,
            city: this.state.city,
            state: this.state.state,
            country: this.state.country,
            timezone: this.state.timezone,
            urlKey: this.state.urlKey,
            contactEmail: this.state.contactEmail,
            infoLink: this.state.infoLink,
            infoLinkText: this.state.infoLinkText,
            sponsoredIcon: this.state.sponsoredIcon,
            translationFile: this.state.translationFile,
            translationData: this.state.translationData,
            mainIcon: this.state.mainIcon
          })
        }
      } else {
        this.setState({currentErrorMessages})
      }
    }
  }

  renderSponsoredIconField() {
    if (this.state.iconKey) {
      return <div className="field">
        <div className="title">
          <span>
            <span>RENTER ICON:</span>
            <span className="comment">Square image (equal width and height) to show on the exhibit and in screen test credits</span>
          </span>
        </div>
        <div className="clearable-value">
          {/* <input onChange={(event) => this.onFieldChange('sponsoredIcon', event)} type="file" /> */}
          <div>{this.state.iconKey}</div>
          <img onClick={() => this.setState({iconKey: ''})} src={icClose} />
        </div>
      </div>
    } else {
      return <div className="field">
        <div className="title">
          <span>
            <span>RENTER ICON:</span>
            <span className="comment">Square image (equal width and height) to show on the exhibit and in screen test credits</span>
          </span>
        </div>
        <input name="sponsoredIcons" value={this.state.sponsoredIcon ? this.state.sponsoredIcon.filename : ''} onChange={(event) => this.onFieldChange('sponsoredIcon', event)} type="file" />
      </div> 
    }
  }

  renderMainSponsorLogoField() {
    if (this.state.mainIconKey) {
      return <div className="field">
        <div className="title">SPONSOR LOGO</div>
        <div className="clearable-value">
          {/* <input onChange={(event) => this.onFieldChange('sponsoredIcon', event)} type="file" /> */}
          <div>{this.state.mainIconKey}</div>
          <img onClick={() => this.setState({mainIconKey: ''})} src={icClose} />
        </div>
      </div>
    } else {
      return <div className="field">
        <div className="title">
          <span>
            <span>SPONSOR LOGO:</span>
            <span className="comment">393x45 pixel header image to show in exhibit and on download page</span>
          </span>
        </div>
        <input name="mainIcon" value={this.state.mainIcon ? this.state.mainIcon.filename : ''} onChange={(event) => this.onFieldChange('mainIcon', event)} type="file" />
      </div> 
    }
  }

  renderTranslationsField() {
    if (this.props.editingLocation && this.state.translationData && this.state.translationData !== "null") {
      return <div className="field">
        <div className="title">Translation File</div>
        <div className="clearable-value">
          <a href={`/locations/${this.props.editingLocation.id}/download_translation_data`}>Download Translation File</a>
          <img onClick={() => this.setState({translationData: null, translationFile: null})} src={icClose} />
        </div>
      </div>
    } else {
      return <div className="field">
        <div className="title">
          <span>
            <span>Translation File:</span>
            <span className="comment">See an administrator for csv template</span>
          </span>
        </div>
        <input name="translationFile" value={this.state.translationFile ? this.state.translationFile.filename : ''} onChange={(event) => this.onFieldChange('translationFile', event)} type="file" />
      </div> 
    }
  }

  renderErrors() {
    if (this.state.currentErrorMessages.length > 0) {
      return <div className="field">
        {this.state.currentErrorMessages.map(e => {
          return <div className="error">{e}</div>
        })}
      </div>
    }
  }

  render() {
    return (
      <div className={`edit-dialog ${this.props.show ? 'show' : ''}`}>
        <div className="content search">
          <div className="dialog-title">{this.getTitleText()}</div>
          <div className="fields">
            <div className="field">
              <div className="title">
                <span>
                  <span>LOCATION NAME</span>
                </span>
              </div>
              <input onChange={(event) => this.onFieldChange('name', event)} value={this.state.name} type="text" />
            </div>
            <div className="field">
              <div className="title">CITY</div>
              <input onChange={(event) => this.onFieldChange('city', event)} value={this.state.city} type="text" />
            </div>
            <div className="field">
              <div className="title">STATE</div>
              <input onChange={(event) => this.onFieldChange('state', event)} value={this.state.state} type="text" />
            </div>
            <div className="field">
              <div className="title">COUNTRY</div>
              <input onChange={(event) => this.onFieldChange('country', event)} value={this.state.country} type="text" />
            </div>
            <div className="field">
              <div className="title">TIMEZONE</div>
              <select value={this.state.timezone} onChange={(event) => this.onFieldChange('timezone', event)}>
                { this.renderTimeZones() }
              </select>
            </div>
            <div className="field">
              <div className="title">
                <span>
                  <span>URL KEY:</span>
                  <span className="comment">Url Identifier for downloads: e.g. /recordings/your-key/download</span>
                </span>
              </div>
              <input onChange={(event) => this.onFieldChange('urlKey', event)} value={this.state.urlKey} type="text" />
            </div>
            <div className="field">
              <div className="title">
                <span>
                  <span>INFO LINK:</span>
                  <span className="comment">Info link to display/link on recording download emails (e.g. https://www.warhol.org).</span>
                </span>
              </div>
              <input onChange={(event) => this.onFieldChange('infoLink', event)} value={this.state.infoLink} type="text" />
            </div>
            <div className="field">
              <div className="title">
                <span>
                  <span>INFO LINK TEXT:</span>
                  <span className="comment">Link text to display for the info link (e.g. warhol.org)</span>
                </span>
              </div>
              <input onChange={(event) => this.onFieldChange('infoLinkText', event)} value={this.state.infoLinkText} type="text" />
            </div>
            <div className="field">
              <div className="title">
                <span>
                  <span>CONTACT EMAIL:</span>
                  <span className="comment">Where should users contact you with questions/requests?</span>
                </span>
              </div>
              <input onChange={(event) => this.onFieldChange('contactEmail', event)} value={this.state.contactEmail} type="text" />
            </div>
            {this.renderSponsoredIconField()}
            {this.renderMainSponsorLogoField()}
            {this.renderTranslationsField()}
            {this.renderErrors()}
          </div>
          <div className="bottom-buttons">
            <div onClick={this.save.bind(this)} className={`action-button ${this.isReadyToSubmit() ? 'enable' : 'disable'}`}>{this.getSubmitText()}</div>
          </div>
          <img onClick={this.props.closeDialog.bind(this)} className="close" src={icClose}/>
        </div>
      </div>
    );
  }
}

export default LocationsDialog;